import { useMemo } from 'react';

export const useDuvalPentagonData = (values, variables, variablesIndex, isPreview) => {
  return useMemo(() => {
    if (!values) return [];

    const hasConfig = variables.some((variable) =>
      values.some((value) => value.variable === variable.id)
    );

    if (!hasConfig) return [];

    return values.reduce((acc, { values: dataValues, name, granularity }) => {
      for (const [time, value, quality] of dataValues) {
        const parsedValue = Number.parseFloat(value);
        const cleanedValue = Number.isNaN(parsedValue) ? undefined : parsedValue;

        let axisAlignedValue = cleanedValue;

        if (quality !== 1) axisAlignedValue = null;

        const index = acc.findIndex((entry) => entry.time === time);
        if (index === -1) {
          const insertIndex = acc.findIndex(
            (_, index_) => acc[index_].time > time && (acc[index_ - 1] || {}).time < time
          );
          if (insertIndex === -1) {
            acc.push({
              time,
              [name]: axisAlignedValue,
              granularity,
            });
          } else {
            acc = [
              ...acc.slice(0, insertIndex),
              {
                time,
                [name]: axisAlignedValue,
                granularity,
              },
              ...acc.slice(insertIndex),
            ];
          }
        } else {
          acc[index] = {
            ...acc[index],
            [name]: axisAlignedValue,
          };
        }
      }
      return acc;
    }, []);
  }, [values, variables, variablesIndex, isPreview]);
};
